import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { EdhDokument, EdhService } from "@e-forsyning/common/edh";

import { UmbracoDokumentIndstillinger } from "../model/umbraco-dokument-indstillinger";
import { DokumentRepository } from "./dokument.repository";

@Injectable({ providedIn: "root" })
export class DokumentService {
    constructor(private readonly repository: DokumentRepository, private readonly edhService: EdhService) {}

    public hentDokumenter(antalAarTilbageITiden: number = 1000): Observable<EdhDokument[]> {
        return this.edhService.hentDokumenterForAktuelInstallation(antalAarTilbageITiden);
    }

    public hentDokumentUrler(dokumentnummer: number): Observable<string[]> {
        return this.edhService.hentDokumentUrlerForAktuelInstallation(dokumentnummer);
    }

    public hentUmbracoIndstillinger(): Observable<UmbracoDokumentIndstillinger> {
        return this.repository.hentUmbracoIndstillinger();
    }
}
